export const SupportedNetworks: { [key: number]: string } = {
  1: 'Ethereum Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  5: 'Goerli',
  56: 'Binance Smart Chain',
  137: 'Polygon',
  17000: 'Holesky',
  97: 'Binance Smart Chain Testnet',
  80002: 'Polygon Testnet',
  11155111: 'Sepolia',
  // Add more networks as needed
};
